import { useEffect, useState } from "react";
import CategoryService from "../services/CategoryService";
import ICategory from "../entities/ICategory";
import { unwrapList } from "../services/apiUtils";

let cache: Record<number, string> | null = null;
let inflight: Promise<Record<number, string>> | null = null;

const loadLookup = (): Promise<Record<number, string>> => {
  if (cache) return Promise.resolve(cache);
  if (!inflight) {
    inflight = CategoryService.getCategory()
      .then((res: any) => {
        const map: Record<number, string> = {};
        unwrapList<ICategory>(res).forEach((c) => {
          map[c.categoryId] = c.title || `#${c.categoryId}`;
        });
        cache = map;
        return map;
      })
      .catch(() => ({} as Record<number, string>))
      .finally(() => {
        inflight = null;
      });
  }
  return inflight;
};

/** Call after creating / renaming / deleting a category so the next read is fresh. */
export const invalidateCategoryLookup = () => {
  cache = null;
};

/** Returns a map of categoryId -> category title (empty until loaded). */
const useCategoryLookup = (): Record<number, string> => {
  const [lookup, setLookup] = useState<Record<number, string>>(cache || {});
  useEffect(() => {
    let active = true;
    loadLookup().then((m) => active && setLookup(m));
    return () => {
      active = false;
    };
  }, []);
  return lookup;
};

export default useCategoryLookup;
